import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ResponsiveTable from "../elements/ResponsiveTable";
import Disclaimer2 from "../elements/Disclaimer2";
import Button from "../elements/Button";
import TickList from "../elements/TickList";
import globals from '../globals';
import {
    CARRIER_AAPT, CARRIER_DGTEK,
    CARRIER_NBN,
    CARRIER_OPTUS,
    CARRIER_TELSTRA,
    CARRIER_VOCUS,
    CARRIERS,
    mapCarriersToData
} from "../constants";

const mapLogos = {};
mapLogos[CARRIER_TELSTRA] = 'logo-telstra.svg';
mapLogos[CARRIER_OPTUS] = 'logo-optus.svg';
mapLogos[CARRIER_AAPT] = 'logo-aapt.svg';
mapLogos[CARRIER_NBN] = 'logo-nbn.svg';
mapLogos[CARRIER_VOCUS] = 'logo-vocus.svg';
mapLogos[CARRIER_DGTEK] = 'logo-dgtek.svg';

const promos = {};
//promos[NETWORK_TELSTRA] = 'First three months on any new order';
//promos[NETWORK_OPTUS] = '';
//promos[NETWORK_AAPT] = 'FREE router';
//promos[NETWORK_NBN_ENTERPRISE] = '';
//promos[NETWORK_VOCUS] = '';

const unavailable = 'This speed unavailable at your address';
const unavailableAapt = `${unavailable}<br /><small>(AAPT supports 1000 Mbps only)</small>`;

const PlanResultsTableAsync = (props) => {

	const hasPromos = Object.keys(promos).length > 0;
	const headings = hasPromos ? ['', '12 months', '24 months', '36 months', 'Comments'] : ['', '12 months', '24 months', '36 months'];

	const getPromo = key => {
		return promos[key] ? promos[key] : '';
	};

	const buildCell = (carrier, plan) => {
	    if (!props.carriersLoaded.includes(carrier)) {
            return '<span class="loader-text-solo">loading</span>';
        } else if (props.carriersDisabled.includes(carrier)) {
	        return carrier === CARRIER_AAPT ? unavailableAapt : unavailable;
        } else if (props.carrierErrors.includes(carrier)) {
	        return 'An error occurred loading this pricing.';
        } else if (plan) {
			return `Monthly fee: <span class="bold">$${globals.addDecimals(plan.monthly_rental)}</span><br />Activation fee: <span class="bold">$${globals.addDecimals(plan.installation)}</span>`;
		} else {
			return 'This option unavailable at your address';
		}
	};

	const buildClassName = carrier => {
	    return `
	        ${props.carriersLoaded.includes(carrier) ? '' : 'loading'}
	        ${props.carriersDisabled.includes(carrier) ? 'disabled' : ''} 
	        ${props.carrierErrors.includes(carrier) ? 'error' : ''} `;
    };

	const NoResults = (
		<div className="no-results centered">
			<h2 className="mb-2">No results</h2>
			<p className="mt-0 mb-5">We can not find a product which matches your address and speed requested.<br />Please try selecting a different speed or give us a call on 1300 393 835 to discuss another solution.</p>
		</div>
	);

	const getHeadings = () => {
        return headings.map((item, key) => {
            return (
                <td key={key} dangerouslySetInnerHTML={{__html: item}} />
            );
        });
    };

	const getRows = (isMobile = false) => {
        return CARRIERS.map((carrier, key) => {
            let plan = props.plans[carrier];
            let data = [
                `<div class="centered"><img src="/images/logos/${mapLogos[carrier]}" alt="${carrier}" /></div>`,
                buildCell(carrier, plan && plan.one_year ? plan.one_year : null),
                buildCell(carrier, plan && plan.two_years ? plan.two_years : null),
                buildCell(carrier, plan && plan.three_years ? plan.three_years : null)
            ];

            if (hasPromos) {
                data.push(`<span class="bold">${getPromo(carrier)}</span>`);
            }

            return isMobile ?
                data.map((item, innerKey) => {
                    return (
                        <div key={innerKey} className={`Rtable-cell count-${innerKey} ${buildClassName(carrier)}`}>
                            <span>{headings[innerKey]}</span>
                            <div dangerouslySetInnerHTML={{__html: item ? item : '&nbsp;'}} />
                        </div>
                    );
                })
            :
                <tr key={key} className={buildClassName(carrier)}>
                    {data.map((item, innerKey) => {
                        return (
                            <td key={innerKey}><div dangerouslySetInnerHTML={{__html: item}} /></td>
                        );
                    })}
                </tr>;
        });
    };

	return (
		<div className="plans-container mb-4">
			<div className="plans-table">
				{props.hasResults ? <h2 className="centered w-100 m-0 mb-5">The following network options are available at your address</h2> : ''}
				{props.hasResults ? <TickList list={[`${props.speed}Mbps`, 'Unlimited downloads']} reverse={true} /> : ''}
                {props.completedWithoutResults ? NoResults :
                    <div className="responsive-table">
                        {/* DESKTOP */}
                        <table>
                            <thead>
                            <tr>
                                {getHeadings()}
                            </tr>
                            </thead>
                            <tbody>
                            {getRows()}
                            </tbody>
                        </table>
                        {/* MOBILE */}
                        <div className={`Rtable Rtable--${headings.length}cols Rtable--collapse`}>
                            {getRows(true)}
                        </div>
                    </div>
                }

                {props.children}

                <div className="mt-4">
                    <div className="buttons">
                        <Button
                            action="tel: 1300 393 835"
                            image="/images/btn-phone.svg"
                            alt="Call Us"
                        />
                    </div>
                </div>
				<Disclaimer2 />
			</div>
		</div>
	);

};

PlanResultsTableAsync.propTypes = {
	plans: PropTypes.object.isRequired,
	speed: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    carriersDisabled: PropTypes.array.isRequired,
    carriersLoaded: PropTypes.array.isRequired,
    carrierErrors: PropTypes.array.isRequired,
    hasResults: PropTypes.bool.isRequired,
    completedWithoutResults: PropTypes.bool.isRequired
};

export default PlanResultsTableAsync;


// WEBPACK FOOTER //
// ./resources/assets/js/modules/PlanResultsTableAsync.js